@if (content && (content.contentHTML || content.title) || isDestinationMapTooltip) {
  <div class="custom-tooltip" appTooltipElement
       [class.custom-tooltip--top]="tooltipPosition === TooltipPosition.TOP"
       [class.custom-tooltip--bottom]="tooltipPosition === TooltipPosition.BOTTOM"
       [style.visibility]="displayTooltip ? 'visible' : 'hidden'"
       [style.opacity]="displayTooltip ? '1' : '0'"
       [style.top]="topPosition + 'px'"
       [style.left]="leftPosition + 'px'"
       [ngStyle]="{'--arrowPosition': arrowPosition, '--maxWidth': maxWidth}"
  >
    @if (!isDestinationMapTooltip) {

      @if (content && content.title) {
        <p class="custom-tooltip__title">{{ content.title }}</p>
      }

      @if (content && content.subtitle) {
        <p class="custom-tooltip__subtitle">{{ content.subtitle }}</p>
      }

      @if (content && content.contentHTML) {
        <div class="custom-tooltip__content"
             [innerHtml]="content.contentHTML | safeHtml: SanitizerValueType.HTML">
        </div>
      }
    } @else {
      <app-destination-map-tooltip
        [content]="content.destinationMapTooltipContent"
      ></app-destination-map-tooltip>
    }
  </div>
}

